// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { snjGradientBackgroundPosition, snjGradientBackgroundSize } from '@tcp/core/styles/utils';
import { getViewportInfo, getIconPath } from '@tcp/core/src/utils';

const getWidth = ({ isMobileNavigationRedesignEnabled }) => {
  return isMobileNavigationRedesignEnabled ? '343px' : '314px';
};

const footerStyles = css`
  #tcp-nav-drawer footer {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      padding-top: 0;

      .offer-zone,
      .accordion.accordian-head-new {
        font-family: Nunito;
        font-size: 12px;
        font-weight: 500;
        line-height: 150%;
        letter-spacing: 0.12px;
      }

      .open,
      .closed {
        background-image: url(${(props) => getIconPath('chevron-right', props)});
        height: 20px;
        width: 20px;
      }

      .open {
        transform: rotate(-90deg);
      }

      .closed {
        transform: rotate(90deg);
      }

      .accordion.accordian-head-new:after {
        content: url(${(props) => getIconPath('chevron-right', props)});
        height: 20px;
        width: 20px;
        top: 18px;
      }
    }

    .accordion.accordian-head-new.inactive:after {
      transform: rotate(-90deg);
    }
    .accordion.accordian-head-new.active:after {
      transform: rotate(90deg);
    }
  }
`;

export default css`
  ${(props) =>
    props.isShowNavAnimation
      ? `
  @keyframes slideIn {
    0% {
      opacity: 0;
      left: -${getWidth(props)};
    }
    100% {
      opacity: 1;
      left: 0;
    }
  }
  @keyframes slideIn1 {
    0% {
      opacity: 0;
      width: 0;
      left: ${getWidth(props)};
    }
    100% {
      opacity: 1;
      width: ${getWidth(props)};
      left: 0;
    }
  }
  `
      : `
  @-webkit-keyframes slideIn {
    0% {
      transform: translate(-${getWidth(props)}, -155px);
    }
    90% {
      transform: translate(5px, -155px);
    }
    100% {
      transform: translate(0, -155px);
    }
  }
  @-moz-keyframes slideIn {
    0% {
      transform: translate(-${getWidth(props)}, -155px);
    }
    90% {
      transform: translate(5px, -155px);
    }
    100% {
      transform: translate(0, -155px);
    }
  }
  @keyframes slideIn {
    0% {
      transform: translate(-${getWidth(props)}, -155px);
    }
    90% {
      transform: translate(5px, -155px);
    }
    100% {
      transform: translate(0, -155px);
    }
  }
  @-webkit-keyframes slideLeft {
    0% {
      transform: translate(-${getWidth(props)}, -155px);
    }
    100% {
      transform: translate(0, -155px);
    }
  }
  @-moz-keyframes slideLeft {
    0% {
      transform: translate(-${getWidth(props)}, -155px);
    }
    100% {
      transform: translate(0, -155px);
    }
  }
  @keyframes slideLeft {
    0% {
      transform: translate(400px, -155px);
    }
    100% {
      transform: translate(0px, -155px);
    }
  }`}
  .tcp-drawer-overlay {
    background: ${(props) => props.theme.colorPalette.black};
    position: absolute;
    z-index: 900;
    height: 100%;
    opacity: 0.6;
    width: 100%;
  }
  .is-hidden {
    display: none;
  }
  .tcp-drawer__isOpen_${(props) => props.navigationLevel} {
    display: block;
    position: absolute;
    z-index: ${(props) => props.theme.zindex.zDrawer};
    top: ${(props) => (props.position && props.position.top) || 0};
    left: ${(props) => (props.position && props.position.left) || 0};
    width: ${(props) => getWidth(props)};
    height: ${(props) => props.height || `auto`};
  }
  ${(props) =>
    props.isShowNavAnimation
      ? `
  .tcp-drawer__isOpen_l1 {
    animation: slideIn 0.5s forwards;
  }
  .tcp-drawer__isOpen_l2,
  .tcp-drawer__isOpen_l3 {
    animation: slideIn1 0.5s forwards;
  }`
      : ''}
  .tcp-condensed-drawer {
    position: fixed;
    top: 58px;
  }
  .tcp-drawer-content {
    width: ${(props) => props.width.small || `100%`};
    background: ${(props) => props.theme.colorPalette.white};
    height: ${(props) => (props.isShowNavAnimation ? '100%' : props.height || 'auto')};
    ${(props) =>
      !props.isHamburgerMenuRedesignEnabled && !props.isMobileNavigationRedesignEnabled
        ? `padding-top: 16px;`
        : ``}
  }
  .display-small-none {
    display: none;
  }
  .drawer-close-icon {
    background: white;
    position: absolute;
    right: -44px;
    color: red;
    z-index: 100;
    width: 31px;
    height: 31px;
    border-radius: 50%;
  }
  .drawer-close-img {
    margin-top: 9px;
    margin-left: 9px;
    height: 13px;
  }
  .account-main-section {
    cursor: pointer;
    width: ${(props) => getWidth(props)};
    display: flex;
    align-items: center;
    position: fixed;
    padding: 9px 14px;
    background: ${(props) => props.theme.brandSpecificStyles.L2_MOBILE_BG_COLOR};
    box-sizing: border-box;
    min-height: 50px;
    ${(props) => (props.isShowNavAnimation ? 'animation: slideIn 0.5s forwards;' : 'left: 0px;')}
    ${(props) =>
      props.isHamburgerMenuRedesignEnabled
        ? ` padding: ${props.theme.spacing.ELEM_SPACING.REG} ${props.theme.spacing.ELEM_SPACING.MED};
      `
        : ''}
  }

  ${(props) => (props.isMobileNavigationRedesignEnabled ? footerStyles : '')}

  #sideNavUserInfo.account-main-section.account-main-section-mobile-redesign {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      padding: 20px 16px;
      background: #f3f3f3;
      min-height: 58px;

      .rightLink {
        border-left: none;
      }

      .rightLink.login-header-label,
      .create-account-header-label {
        color: #000;
        font-family: Nunito;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
        text-decoration: underline;
      }

      .rightLink.login-header-label:after,
      .account-info-point-and-rewards-wrapper:after {
        content: '';
        height: 12px;
        width: 1px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background-color: #000;
      }

      .account-info-section {
        padding: 0;
        background: transparent;
        border: none;
        display: flex;
        align-items: center;
        column-gap: 8px;
      }

      .account-info.user-name {
        color: #000;
        font-family: Nunito;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
        text-transform: capitalize;
      }

      .account-info-point-and-rewards-wrapper {
        padding-left: 8px;
        position: relative;
        display: flex;
        align-items: center;
      }

      .account-info.user-points,
      .account-info.user-rewards {
        color: #595959;
        font-family: Nunito;
        font-size: 10px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
        letter-spacing: 0.1px;
      }

      .account-info.user-rewards {
        margin-left: 4px;
        padding-left: 8px;
        position: relative;
      }

      .account-info.user-rewards:after {
        content: '/';
        height: 10px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-70%);
      }

      .manage-account-wrapper {
        width: auto;
        margin-right: 0;
        margin-left: auto;
      }

      .manage-account {
        position: unset;
      }

      .manage-account-wrapper,
      .manage-account,
      .manage-account a {
        color: #000;
        font-family: Nunito;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
        text-decoration: underline;
      }
    }
  }
  .account-hamburger-section {
    cursor: pointer;
    width: ${(props) => getWidth(props)};
    display: flex;
    align-items: center;
    padding: 9px 14px;
    background: #f3f3f3;
    box-sizing: border-box;
    min-height: 50px;
    margin: 0px -15px;
    ${(props) => (props.isShowNavAnimation ? 'animation: slideIn 0.5s forwards;' : 'left: 0px;')}
    ${(props) =>
      props.isHamburgerMenuRedesignEnabled
        ? ` padding: ${props.theme.spacing.ELEM_SPACING.SM} ${props.theme.spacing.ELEM_SPACING.MED};
      `
        : ''}
  }
  .hamburger-item {
    text-align: center;
    padding: ${(props) =>
      `${props.theme.spacing.ELEM_SPACING.XXS} ${props.theme.spacing.ELEM_SPACING.XS_1}`};
    width: ${(props) =>
      props.theme.brand === 'snj' || props.theme.brand === 'pjp' ? `50%` : `33%`};
  }
  .hamburger-icon {
    height: 16px;
  }

  .newhamburger-menu-wrapper {
    min-width: max-content;
    ${(props) => (props.isHeaderNewSection ? `margin-bottom: 10px;` : '')}
  }

  .icon-text {
    text-transform: capitalize;
    font-size: 13px;
  }
  .orderCount {
    background: ${(props) => props.theme.brandSpecificStyles.CART_ITEM_COUNT_BACKGROUND_COLOR};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    margin: ${(props) => `1px 0px 0px -${props.theme.spacing.ELEM_SPACING.XS_7}`};
    padding: ${(props) => `1px ${props.theme.spacing.ELEM_SPACING.XXS}`};
    color: ${(props) => props.theme.colors.WHITE};
  }
  .account-main-section-snj {
    background-size: ${(props) => {
      const width = getViewportInfo()?.isTablet ? 125 : 300;
      return snjGradientBackgroundSize(width, 25, props.visibleItemCount + 1);
    }};
    background-position: ${(props) =>
      snjGradientBackgroundPosition(props.visibleItemCount + 1, props.selectedL1Index + 1)};
  }
  .account-info {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    cursor: pointer;
    display: inline-flex;
    align-items: center;
  }
  #sideNavUserInfo .account-info.user-name {
    color: black !important;
  }
  .user-name {
    font-size: ${(props) => props.theme.typography.fontSizes.fs13};
    text-align: left;
  }
  .user-points,
  .user-rewards {
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
  }
  .manage-account {
    position: absolute;
    top: 35%;
    right: 6%;
  }
  .rightLink {
    border-left: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    box-sizing: border-box;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    min-width: ${(props) => props.theme.spacing.ELEM_SPACING.XXXL};
    border-radius: 0px;
  }
  .snjBorder {
    border-left: 1px solid ${(props) => props.theme.colors.PRIMARY.DARK};
    @media ${(props) => props.theme.mediaQuery.large} {
      border-left: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    }
  }
  .input-checkbox-wrapper {
    display: flex;
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .tcp-drawer__isOpen {
      top: ${(props) => (props.position && props.position.topMedium) || 0};
    }
    .tcp-condensed-drawer {
      position: fixed;
      top: 62px;
    }
    .tcp-drawer-content {
      width: ${(props) => props.width.medium || `100%`};
    }
    .display-small-none {
      display: block;
    }
    .display-medium-none {
      display: none;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .tcp-drawer-content {
      width: ${(props) => props.width.large || `100%`};
      background: none;
    }
    .display-medium-none {
      display: block;
    }
    .display-large-none {
      display: none;
    }
  }
`;
